// extracted by mini-css-extract-plugin
export var content = "_5y-3";
export var list = "_5y-4";
export var settingsContent = "_5y-7";
export var settingsPanel = "_5y-8";
export var state = "_5y-6";
export var triggerBadge = "_5y-2";
export var triggerButton = "_5y-1";
export var triggerShell = "_5y-0";
export var unreadDot = "_5y-5";